<template>
  <div class="main" id="main">
    <div class="headerBox">
      <van-nav-bar class="title" title="速得尔网上直播"  >
      </van-nav-bar>
    </div>
    <div class="matchList"> 
      <van-collapse   v-model="activeNames" >
        <van-collapse-item :title="itemYear" :name="itemYear" v-for="itemYear in arrMatchYear()" :key="itemYear">
          <template #title>
            <div class="yearItem">{{itemYear}} </div>
          </template>
          <van-list>
            <van-cell
              v-for="item  in getMatchList(itemYear)"
              :key="item"
              :title="item"
              @click="changeMatchFun(item)"
            >
              <div class="matchName">
                <div class="borderBox van-hairline--bottom">
                  <span>{{item.matchName}}</span>
                  <van-icon class="icon" name="arrow" />
                </div>
              </div>
            </van-cell>
          </van-list>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import {ref, computed, reactive, toRefs } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
var opt;
export default {
  setup() { 
    const data = reactive(createState);
    const router = useRouter();
    function goFun(url, topicData) {
      router.push({
        path: url,
        query: topicData
      });
    }
    return {
      state: reactive(createState),
      Paho: Paho,
      goFun,
      client: ref({}),
      menuList: ref(data.menuList),
      activeNames:ref([]),
      firstshowYear:ref(true)
    };
  },
  methods: {
    //选择年份
    changecollapseFun(event,item){
      debugger
      console.log(event)
      console.log(this.activeNames)
      // this.activeNames = [event[event.length-1]]
    },
    //选择比赛
    changeMatchFun(data) {
      console.log(data)
      //将请求的topic赋值到公共参数中
      this.state.selectedMatchId = data.matchId;
      this.state.matchName = data.matchName;
      this.state.groupList.value = this.arrMatchGroup();
      this.state.projectList.value = this.arrMatchProject(this.state.groupList.value[0]);
      this.state.active = this.arrMatchGroup()[0];
      console.log(this.state)
      // this.getfileFun()
      const topicData = {
          selectedMatchId:data.matchId,
        };
      this.goFun("/project", topicData);
    },
    //获取pdf
    
    getfileFun(){
      // console.log(this.state.selectedMatchId)
      const data= {
        'matchId' :this.state.selectedMatchId
      }
      this.$http.get('/File/GetMatchFiles?matchId='+this.state.selectedMatchId,data,{
        headers:{
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
      })
      .then((res)=>{
        console.log(res)
        if(res.status==200&&res.data.Code==0){
          this.state.pdfmatchList = res.data.Result[0].MatchFileList
          this.state.pdfprojectList = res.data.Result[0].ProjectFileList
          this.state.pdfmatchList.map((item)=>{
            if(item.FileType==100){//比赛秩序单
              item.name = '比赛秩序单'
            }else if(item.FileType==101){//比赛成绩册
              item.name = '比赛成绩册'
            }
          })
          this.state.pdfprojectList.map((item)=>{
             if(item.FileType==200){//项目秩序单
              item.name = '项目秩序单'
            }else if(item.FileType==2001){//比赛成绩册
              item.name = ' 项目成绩单'
            }
          })
          
        }else if(res.status==200&&res.data.Code==204){
          console.log('无数据')
           this.state.pdfmatchList = []
           this.state.pdfprojectList = []
        }
        const topicData = {
          selectedMatchId:data.matchId,
        };
        console.log(this.state)
        this.goFun("/project", topicData);
      })
      .catch((res)=>{
        
        console.log(res)
      })
    },
    onChange() {
      console.log("点击了轮播图");
    },
    //处理数据
    handleFun(data) {
      this.menuList.value = data.menuList;
      this.menuList.value = this.getMatchList()
      console.log(this.menuList)
    },
    mqttFun() {
      this.client = new Paho.MQTT.Client(
        this.state.brokerip,
        8083,
        "WX_Login" + new Date().getTime()
      );
      var _client = this.client;
      var _this = this;
      opt = this.options = {
        timeout: 5,
        keepAliveInterval: 50,
        reconnect: true, // Enable automatic reconnect
        cleanSession: false,
        useSSL: false,
        userName: "",
        password: "",
        onSuccess: function(responseObject) {
          console.log("连接成功");
          _this.topicFun();
        },
        onFailure: function(e) {
          setTimeout(function() {
            _client.connect(opt);
          }, 5000);
        }
      };
      this.client.connect(opt); //连接服务器并注册连接成功处理事件
      this.client.onConnectionLost = this.onConnectionLost; //注册连接断开处理事件
      this.client.onMessageArrived = this.onMessageArrived; //注册消息接收处理事件
    },
    topicFun() {
      const MQTT_TOPIC =this.state.matchTopic;
      this.client.subscribe(MQTT_TOPIC); //订阅监控通用指令
    },
    onConnectionLost: function(responseObject) {
      console.log(responseObject)
      if (responseObject.errorCode !== 0) {
        console.log("onConnectionLost:" + responseObject.errorMessage);
        this.connected = false;
        console.log("连接已断开");
        console.log(this.client.isConnected());
      }
    },
    onMessageArrived: function(message) {
      // this.payloadFun(message)
      // console.log(
      //   "收到paho消息:" + message.topic + "/n" + message.payloadString
      // );
      try {
        const list = JSON.parse(message.payloadString);
        console.log(list)
        this.handleFun(list);
      } catch (error) {
        console.log(error);
      }
    },
    // 处理select筛选后的数组
    selectedLiveMenu() {
      return this.state.matchList.value.menuList.filter(match => {
        return match.matchId == this.state.selectedMatchId;
      });
    },
    // 2根据组别筛选比赛
    filterliveMenuByGroup(group) {
      return this.selectedLiveMenu().filter(item => {
        return item.matchGroupName == group;
      });
    },
    // 3根据组别和项目筛选项目类别
    filterliveMenuByPrjoect(group, project) {
      return this.filterliveMenuByGroup(group)
        .filter(item => {
          return item.projectName == project;
        })
        .sort((a, b) => {
          return new Date(a.startTime) - new Date(b.startTime);
        });
    },
    // 获取所有年份
    arrMatchYear() {
      if(this.menuList.value==undefined){
        return
      }
      let arr = [];
      this.menuList.value.forEach(item => {
        if (arr.indexOf(item.matchYear) == -1) {
          arr.push(item.matchYear);
        } else {
          return false;
        }
      });
      if(this.activeNames.length==0&&this.firstshowYear){
        this.activeNames = [arr.sort().reverse()[0]]
        this.firstshowYear = false
      }
      return arr.sort().reverse();
    },
    // 获取所有组别
    arrMatchGroup() {
      let arr = [];
      this.selectedLiveMenu().forEach(item => {
        if (arr.indexOf(item.matchGroupName) == -1) {
          arr.push(item.matchGroupName);
        } else {
          return false;
        }
      });
      return arr;
    },
    // 获取所有项目
    arrMatchProject(title) {
      let arr = [];
      this.filterliveMenuByGroup(title).forEach(item => {
        let add = true;
        arr.forEach(arrItem => {
          if (arrItem[0] == item.projectName) {
            add = false;
            return false;
          } else {
            return false;
          }
        });
        if (add) {
          arr.push([item.projectName, item.topic]);
        }
      });
      return arr;
    },
    // 根据年份获取比赛列表
    getMatchList(year) {
        let arr = [];
        let arrMatchId = [];
        //有列表时，默认选中第一个比赛；
        if (this.menuList.length > 0 && this.selectedMatchId == "") {
          this.selectedMatchId = this.menuList[0].matchId;
          this.selectedGroupName = this.menuList[0].matchGroupName;
        };
        this.menuList.value.forEach((item) => {
          if (
            arrMatchId.indexOf(item.matchId) == -1 && item.matchYear == year
          ) {
            arrMatchId.push(item.matchId);
            let addArr = item;
            arr.push(addArr);
          }
        });
        // 设置默认选择项
        return arr;
      },
  },
  mounted() {
    // this.mqttFun();
  },
  created() {},
  computed: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell{
    background: linear-gradient(170deg,#adff2f,#4fc5f3,#1f95d3);
}
.yearItem{
  font-size: 0.4rem;
  font-weight: 700;
  color: #fff;
}
/deep/.van-icon{
  color: #fff;
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 1rem;
  position: fixed;
    background: #fff;
    z-index: 2;
  .title{
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis{
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
  
}
.my-swipe .van-swipe-item {
  height: 4rem;
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
  img {
    width: 100%;
    height: 4rem;
  }
}
.matchList {
  flex: 1;
  margin-top: 1rem;
  height: auto;
  width: 100%;
  background: #fff;
  .van-list {
    width: 100%;
    height: 100%;
    .matchName {
      font-weight: 700;
      width: 100%;
      height: 1rem;
      text-align: left;
      line-height: 1rem;
      font-size: 0.3rem;
      .borderBox {
        // background: linear-gradient(135deg,#1f95d3,#fff);
        width: 96%;
        height: 1rem;
        margin: 0 2%;
        // border-bottom: 1px solid #333;
      }
      span {
        width: 96%;
        height: 1rem;
        box-sizing: border-box;
        display: inline-block;
        word-break: keep-all; /* 不换行 */
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
        text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
        float: left;
      }
      .icon {
        width: 0.2rem;
        height: 1rem;
        line-height: 1rem;
        float: left;
      }
    }
  }
}
</style>